export default __webpack_public_path__ + "static/media/travel-twokitty.dec4cf67.jpeg";